let tickerSpeed2 = 1;

let flickity2 = null;
let isPaused2 = false;
const slideshowE2 = document.querySelector('.collections-slideshow');

const update2 = () => {
  if (isPaused2) return;
  if (flickity2.slides) {
    flickity2.x = (flickity2.x - tickerSpeed2) % flickity2.slideableWidth;
    flickity2.selectedIndex = flickity2.dragEndRestingSelect();
    flickity2.updateSelectedSlide();
    flickity2.settle(flickity2.x);
  }
  window.requestAnimationFrame(update2);
};

const pause2 = () => {
  isPaused2 = true;
};

const play2 = () => {
  if (isPaused2) {
    isPaused2 = false;
    window.requestAnimationFrame(update2);
  }
};

flickity2 = new Flickity(slideshowE2, {
  autoPlay: false,
  prevNextButtons: false,
  pageDots: false,
  draggable: true,
  wrapAround: true,
  selectedAttraction: 0.015,
  friction: 0.25 });

flickity2.x = 0;

slideshowE2.addEventListener('mouseenter', pause2, false);
slideshowE2.addEventListener('focusin', pause2, false);
slideshowE2.addEventListener('mouseleave', play2, false);
slideshowE2.addEventListener('focusout', play2, false);

flickity2.on('dragStart', () => {
  isPaused = true;
});

update2();